<template>
  <div :class="{ hover:active }" class="l-choice">
    <button
      v-for="(item, idx) in selections"
      :key="item.name"
      onselectstart="return false;"
      oncontextmenu="return false;"
      @click="onChoice(item, idx)"
      class="btn"
      :class="{
        disabled: !active,
        default: active,
        error:  choiceIdx === idx&&item.isRight===0,
        correct: choiceIdx === idx&&item.isRight===1,
    }"
    >
      <span class="text">{{ item.name }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'l-choice',
  props: {
    selections: [Array],
    active: [Boolean],
  },
  data() {
    return {
      choiceIdx: -1, //  所选答案索引
    }
  },
  watch: {
    options: {
      handler(val) {
        this.options = val
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onChoice(item, idx) {
      this.choiceIdx = idx
      //  选择答案
      this.$emit('select', item)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
